import config from "@/config";
import http from "@/utils/request";

export default {
	// 获取iOS版本列表（分页）
	list: {
		url: `${config.API_URL}/admin/ios_version/getList`,
		name: "获取iOS版本列表",
		get: async function (data = {}) {
			return await http.get(this.url, data);
		},
	},
	// 新增iOS版本
	create: {
		url: `${config.API_URL}/admin/ios_version/create`,
		name: "新增iOS版本",
		post: async function (data = {}) {
			return await http.post(this.url, data);
		},
	},
	// 修改iOS版本
	update: {
		url: `${config.API_URL}/admin/ios_version/update`,
		name: "修改iOS版本",
		post: async function (data = {}) {
			return await http.post(this.url, data);
		},
	},
	// 删除iOS版本（软删除）
	delete: {
		url: `${config.API_URL}/admin/ios_version/delete`,
		name: "删除iOS版本",
		get: async function (data = {}) {
			return await http.get(this.url, data);
		},
	},
	// 获取iOS版本详情
	detail: {
		url: `${config.API_URL}/admin/ios_version/detail`,
		name: "获取iOS版本详情",
		get: async function (data = {}) {
			return await http.get(this.url, data);
		},
	},
};
